var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resultLabel)?_c('h1',{staticClass:"h4 u-margin-bottom-small u-margin-top u-padding-bottom-small",attrs:{"data-cy":"unit-search-heading"}},[_c('span',[_vm._v(_vm._s(_vm.resultLabel))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }